<template>
    <table class="s-table-fee-type animation-opacity" border="0">
        <thead>
            <th>Cliente</th>
            <th>CI/NIT</th>
            <th>Tipo Trabajo</th>
            <th>Periodo</th>
            <th>Total Precio</th>
            <th>Total Cancelado</th>
            <th>Total por Cobrar</th>
            <th>Acciones</th>
        </thead>
        <tbody>
            <tr
                v-for="(work, index) in listWorks"
                :key="index"
            >
                <td class="s-table-fee-type__border-line">
                    <text-highlight
                        :queries="searchClient"
                    >
                        {{work.client.full_name}}
                    </text-highlight>
                </td>
                <td class="s-table-fee-type__border-line">
                    <text-highlight
                        :queries="searchClient"
                    >
                        {{work.client.ci_nit}}
                    </text-highlight>
                </td>
                <td class="s-table-fee-type__border-line">
                    <v-icon
                        :color="work.cancelled==1 ? 'green' : 'red'"
                        class="mr-1"
                    >{{work.cancelled==1 ? 'mdi-check-circle' : 'mdi-account-cash'}}</v-icon>
                    {{work.fee.fee}}</td>
                <td class="s-table-fee-type__border-line">{{work.period!=null ? work.period : 'S/P'}}</td>
                
                <td class="s-table-fee-type__border-line text-right">
                    {{m_calculation_totalCost(work).toFixed(2)}}</td>
                <td class="s-table-fee-type__border-line" style="text-align:right">
                    {{m_calculation_totalCancelled(work).toFixed(2)}}</td>
                <td class="s-table-fee-type__border-line" style="text-align:right">
                    {{ac_totalDebt(work).toFixed(2)}}</td>
                <td>
                    <div class="d-flex justify-center flex-wrap">
                        <OBtnOptionToolTipComp
                            smsTooltip="Detalle del trabajo"
                            icon="mdi-format-list-checkbox"
                            style="margin:2px"
                            @click="$emit('ckickdetail', work)"
                        />
                        <OBtnOptionToolTipComp
                            smsTooltip="Lista de Pagos"
                            icon="mdi-cash"
                            style="margin:2px"
                            @click="$emit('clickpayments', work)"
                        />
                    </div>
                </td>
            </tr>
            <tr v-if="listWorks.length==0" class="text-center">
                <td colspan="8">SIN DATOS</td>
            </tr>
        </tbody>
    </table>
</template>
<script>
import { OBtnOptionToolTipComp } from '../organisms'
import { calculationsWorkMixin } from '../../mixins'
import TextHighlight from 'vue-text-highlight'
export default {
    mixins: [
        calculationsWorkMixin
    ],
    props: {
        listWorks: Array,
        isReport: {
            default: false,
            type: Boolean
        },
        searchClient: {
            type: String,
            default: ''
        }
    },
    components: {
        OBtnOptionToolTipComp,
        TextHighlight
    },
    methods: {
        ac_totalDebt(work) {
            const debt = this.m_calculation_totalCost(work)-this.m_calculation_totalCancelled(work)
            return debt
        }
    }
}
</script>